import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Banknote, CreditCard, Plus } from 'lucide-react';

interface BankAccountsEmptyStateProps {
  onConnectAccount?: () => void;
}

export function BankAccountsEmptyState({
  onConnectAccount,
}: BankAccountsEmptyStateProps) {
  return (
    <Card className="border-dashed border-2 border-muted-foreground/25 bg-muted/5">
      <CardContent className="flex flex-col items-center justify-center py-12 px-6 text-center">
        {/* Icon */}
        <div className="relative mb-6">
          <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center">
            <CreditCard className="w-8 h-8 text-primary" />
          </div>
          <div className="absolute -top-2 -right-2 w-8 h-8 bg-secondary rounded-full flex items-center justify-center">
            <Banknote className="w-4 h-4 text-secondary-foreground" />
          </div>
        </div>

        {/* Content */}
        <h3 className="text-lg font-semibold mb-2">
          No Bank Accounts Connected
        </h3>
        <p className="text-muted-foreground mb-6 max-w-md">
          Connect your bank accounts to automatically import and categorize
          transactions for your properties.
        </p>

        {/* Action Button */}
        {onConnectAccount && (
          <Button onClick={onConnectAccount} className="flex items-center">
            <Plus className="w-4 h-4 mr-2" />
            Connect Bank Account
          </Button>
        )}

        {/* Additional Info */}
        <div className="mt-6 text-xs text-muted-foreground">
          <p>Automatically sync transactions and apply smart filters</p>
          <p>to categorize income and expenses for your properties.</p>
        </div>
      </CardContent>
    </Card>
  );
}
